"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    verification: {
        url: "/oauth/phone/verification-code",
        method: "POST",
    },
    login: {
        url: "/oauth/token",
        method: "POST",
    },
    logout: {
        url: "/oauth/token",
        method: "DELETE",
    },
    exchangeOldToken: {
        url: "/upgrade-to-v2/token-exchange",
        method: "POST",
    },
};
//# sourceMappingURL=oauth.js.map